import Administracao from '../pages/Administracao/Index.vue'
import IndicadoresPrevineBrasil from '../pages/Administracao/IndicadoresPrevineBrasil/Index.vue'
import GerenciarUsuarios from '../pages/Administracao/GerenciarUsuarios/Index.vue'
import Ressincronizacao from '../pages/Administracao/Ressincronizacao/Index.vue'

export default [
  {
    path: '/administracao',
    component: Administracao,
  },
  {
    path: '/administracao/indicadores-previne-brasil',
    component: IndicadoresPrevineBrasil,
  },
  {
    path: '/administracao/gerenciar-usuarios',
    component: GerenciarUsuarios,
  },
  {
    path: '/administracao/ressincronizacao',
    component: Ressincronizacao,
  },
  {
    path: '/administracao/gerenciar-permissoes',
    component: () =>
      import('@/pages/Administracao/GerenciarPermissoes/Index.vue'),
  },
  {
    path: '/administracao/gerenciar-logotipo',
    component: () =>
      import('@/pages/Administracao/GerenciarLogotipo/Index.vue'),
  },
  {
    path: '/administracao/gerenciar-brasao',
    component: () => import('@/pages/Administracao/GerenciarBrasao/Index.vue'),
  },
  {
    path: '/administracao/equipes-saude',
    component: () => import('@/pages/Administracao/Equipes/Index.vue'),
  },
  {
    path: '/administracao/profissionais-lotacoes',
    component: () =>
      import('@/pages/Administracao/ProfissionaisLotacoes/Index.vue'),
  },
  {
    path: '/administracao/escolas',
    component: () => import('@/pages/Administracao/Escolas/Index.vue'),
  },
  {
    path: '/administracao/microareas',
    component: () => import('@/pages/Administracao/Microareas/Index.vue'),
  },
  {
    path: '/administracao/atencao',
    component: () => import('@/pages/Administracao/Atencao/Index.vue'),
  },
  {
    path: '/administracao/sistemas-externos',
    component: () => import('@/pages/Administracao/SistemasExternos/Index.vue'),
  },
  {
    path: '/administracao/importar-dados',
    component: () => import('@/pages/Administracao/ImportarDados/Index.vue'),
  },
  {
    path: '/administracao/importar-dados/avaliacao-quadrimestral',
    component: () =>
      import(
        '@/pages/Administracao/ImportarDados/AvaliacaoQuadrimestral/Index.vue'
      ),
  },
]
